<template>
  <div :class="`m-3 wrapper wrapper--border wrapper--${bu}`">
    <div class="text-center p-2">
      <h3>Marge controle van: {{ name }}</h3>
      <span @click="previousWeek"><i class="fas fa-arrow-left"></i></span>
      <span class="text-center m-2"
        >Jaar: {{ year_number }} - Week: {{ week_number }}</span
      >
      <span @click="nextWeek"><i class="fas fa-arrow-right"></i></span>
    </div>
    <Loading v-if="loading" />
    <div v-if="!loading">
      <MarginControlTable
        v-if="margin_control"
        :table_data="margin_control"
        :table_style="bu"
      />
      <div v-else class="_text-center program_title">Geen Data</div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import MarginControlTable from "@/components/MarginControlTable.vue";
import request from "@/functions/request.js";
import { addTime, subtractTime } from "@/functions/date.js";
import { msalInstance } from "vue-msal-browser";

export default {
  props: ["bu"],
  components: { Loading, MarginControlTable },
  data: () => ({
    loading: true,
    margin_control: null,
    name: null,
  }),
  created() {
    this.full_date = this.moment();
    this.name = msalInstance.getAllAccounts()[0].idTokenClaims.name;
    this.getData(this.bu);
  },
  watch: {
    bu(newbu) {
      this.loading = true;
      this.margin_control = null;
      this.getData(newbu);
    },
  },
  methods: {
    getData(bu) {
      this.year_number = this.full_date.year();
      this.week_number = this.full_date.week() - 3;
      request(
        `margin-control/${bu}/${this.year_number}/${this.week_number}/${this.name}`,
        "GET"
      ).then(({ margin_control }) => {
        this.margin_control = margin_control[this.name];
        this.loading = false;
      });
    },

    previousWeek() {
      this.loading = true;
      this.margin_control = null;
      this.full_date = subtractTime(1, this.full_date, "weeks");
      this.getData(this.bu);
    },

    nextWeek() {
      this.loading = true;
      this.margin_control = null;
      this.full_date = addTime(1, this.full_date, "weeks");
      this.getData(this.bu);
    },
  },
};
</script>